const UPDATE_BATCH_ASSIGNMENTS = `mutation UpdateAssignments($input: [BatchUpdateAssignmentInput!]!) {
  batchUpdateAssignment(input: $input) {
    assignmentId
    assignmentType
    createdAt
    status
  }
}
`;

export default UPDATE_BATCH_ASSIGNMENTS;
